// import React from 'react';
// import './Footer.css';
// /*
// const OfficeFooter = () => {
//   return (
//     <footer className="footer">
//       <div className="locations">
//         <h2>Our Locations</h2>
//         <div className="location-cards">
//           <div className="location">
//             <iframe
//               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3487.7738307106697!2d77.711314!3d29.053269999999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390c6f77b22ee299%3A0x1e2829abfab0e583!2sUV%20Media!5e0!3m2!1sen!2sin!4v1752912143432!5m2!1sen!2sin"
//               title="UV MEDIA MAP"
//             ></iframe>

//             <h3>Delhi Headquarters</h3>
//              <p>Dh-3, 1, Pallavpuram<br />Meerut, UP 250001</p>
//             <p><strong>📞</strong> 9582860285</p>
//             <a href="https://maps.app.goo.gl/AhFyDECCruJNyHvn6?g_st=ipc/"target="_blank" >GET DIRECTIONS »</a>
//           </div>
//           <div className="location">
//             <h3>Meerut Office</h3>
//             <p>Dh-3, 1, Pallavpuram<br />Meerut, UP 250001</p>
//              <a href="https://maps.app.goo.gl/AhFyDECCruJNyHvn6?g_st=ipc/"target="_blank" >GET DIRECTIONS »</a>
//           </div>
//           <div className="location">
//             <h3>Seattle Office</h3>
//              <p>Dh-3, 1, Pallavpuram<br />Meerut, UP 250001</p>
//              <a href="https://maps.app.goo.gl/AhFyDECCruJNyHvn6?g_st=ipc/"target="_blank" >GET DIRECTIONS »</a>
//           </div>
//         </div>
//       </div>

//       <div className="social-strip">
//         <h3>Join the UV MEDIA Social Community</h3>
//         <div className="social-icons">
//           <a href="#"><i className="fa fa-google-plus"></i> Circle us</a>

//          <a href="https://www.linkedin.com/company/uvmedia18/" target="_blank" rel="noopener noreferrer"><i className="fa fa-linkedin"></i> Linkedin</a>
//           <a href="https://www.instagram.com/uv.media_?igsh=emRoMGkyNGJ1d3lm" target="_blank" rel="noopener noreferrer"><i className="fa fa-facebook"></i> Like us</a>
//           <a href="https://www.instagram.com/uv.media_?igsh=emRoMGkyNGJ1d3lm" target="_blank" rel="noopener noreferrer"><i className="fa fa-instagram"></i> Instagram</a>

//         <a href="https://www.instagram.com/uv.media_?igsh=emRoMGkyNGJ1d3lm" target="_blank" rel="noopener noreferrer"><i className="fa fa-instagram"></i> Follow us</a>
//           <a href="#"><i className="fa fa-rss"></i> Subscribe</a>
//         </div>
//       </div>

//       <div className="bottom-bar">
//         <nav>
//           <a href="#">HOME</a>
//           <a href="#">ABOUT US</a>
//           <a href="#">SERVICES</a>
//           <a href="#">CLIENTS</a>
//           <a href="#">PORTFOLIO</a>
//           <a href="#">CONTACT US</a>
//         </nav>
//         <p>Dh-3, 1, Pallavpuram | Meerut, UP 250001 | 📞 9582860285</p>
//       </div>
//     </footer>
//   );
// };

// export default OfficeFooter; */

// const Footer = () => {
//   return (
//     <footer className="footer">
//       {/* Call to Action Section */}
//       <div className="cta-box">
//         <div className="cta-text">
//           <h3>Ready for a next project?</h3>
//           <p>Let’s get started!</p>
//         </div>
//         <button className="cta-btn">Contact us</button>
//       </div>

//       {/* Footer Links Section */}
//       <div className="footer-main">
//         <div className="footer-col">
//           <h4>COLORLIB</h4>
//           <p>© 2019</p>
//         </div>

//         <div className="footer-col">
//           <h4>Customers</h4>
//           <ul>
//             <li>Buyer</li>
//             <li>Supplier</li>
//           </ul>
//         </div>

//         <div className="footer-col">
//           <h4>Company</h4>
//           <ul>
//             <li>About us</li>
//             <li>Careers</li>
//             <li>Contact us</li>
//           </ul>
//         </div>

//         <div className="footer-col">
//           <h4>Further Information</h4>
//           <ul>
//             <li>Terms & Conditions</li>
//             <li>Privacy Policy</li>
//           </ul>
//         </div>

//         <div className="footer-col">
//           <h4>Follow us</h4>
//           <div className="social-icons">
//             <a href="#"><i className="fab fa-facebook-f"></i></a>
//             <a href="#"><i className="fab fa-twitter"></i></a>
//             <a href="#"><i className="fab fa-linkedin-in"></i></a>
//             <a href="#"><i className="fab fa-medium-m"></i></a>
//             <a href="#"><i className="fab fa-telegram-plane"></i></a>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;

import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer" id="contact">
      {/* CTA Section */}
      <div className="cta-box">
        <div className="cta-text">
          <h3>Ready for your next project?</h3>
          <p>Let’s get started!</p>
        </div>
        <a
          className="cta-btn"
          href="https://forms.gle/BH63MFpPcvg25gRa6"
          target="_blank"
          rel="noopener noreferrer"
          //className="btn btn-glow rounded-pill px-3"
        >
          Contact us
        </a>
      </div>

      {/* Office Info Section */}
      <div className="locations">
        <h2>Our Office</h2>
        <div className="location-info">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3487.7738307106697!2d77.711314!3d29.053269999999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390c6f77b22ee299%3A0x1e2829abfab0e583!2sUV%20Media!5e0!3m2!1sen!2sin!4v1752912143432!5m2!1sen!2sin"
            title="UV MEDIA MAP"
            loading="lazy"
            allowFullScreen
          ></iframe>

          <div className="location-details">
            <h3>UV Media – Meerut Office</h3>
            <p>
              Dh-3, 1, Pallavpuram
              <br />
              Meerut, UP 250001
            </p>
            <p>
              <strong>📞</strong> 9258981818
            </p>
            <a
              href="https://maps.app.goo.gl/AhFyDECCruJNyHvn6?g_st=ipc/"
              target="_blank"
              rel="noopener noreferrer"
            >
              GET DIRECTIONS »
            </a>
          </div>
        </div>
      </div>

      {/* Social Media Section */}
      <div className="footer-social">
        <ul>
          {/* <li>
            <a href="#">
              <i className="fa fa-google-plus"></i> Circle us
            </a>
          </li> */}
          <li>
            <a
              href="https://www.linkedin.com/company/uvmedia18/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa fa-linkedin"></i> LinkedIn
            </a>
          </li>
          {/* <li>
            <a
              href="https://www.instagram.com/uv.media_?igsh=emRoMGkyNGJ1d3lm"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa fa-facebook"></i> Like us
            </a>
          </li> */}
          <li>
            <a
              href="https://www.instagram.com/uv.media_?igsh=emRoMGkyNGJ1d3lm"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa fa-instagram"></i> Instagram
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/@UV-MEDIA">
              <i className="fa fa-rss"></i> Subscribe
            </a>
          </li>
        </ul>
      </div>

      {/* Bottom Bar */}
      {/* <div className="bottom-bar">
        <p>
          <strong>UV MEDIA</strong>
          <br />© 2025
        </p>
        <nav>
          <a href="#">HOME</a>
          <a href="#">ABOUT US</a>
          <a href="#">SERVICES</a>
          <a href="#">CLIENTS</a>
          <a href="#">PORTFOLIO</a>
          <a href="#">CONTACT US</a>
        </nav>
        <p>Dh-3, 1, Pallavpuram | Meerut, UP 250001 | 📞 9258981818</p>
      </div> */}
    </footer>
  );
};

export default Footer;
